import * as React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import * as CompanyActions from '../actions/Company';
import * as LoginActions from '../actions/Login';
import * as BroadcastActions from '../actions/Broadcast';
import * as JobsActions from '../actions/Jobs';
import * as AppliesActions from '../actions/Applies';
import * as ChatActions from '../../chat/actions/Chat';
import * as ProfileActions from '../actions/Profile';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CompanyTabs from '../components/company/CompanyTabs';
import CompanyRep from '../components/company/CompanyRep';
import ChatButton from '../components/chat/ChatButton';
import CompanyAppBar from '../components/company/CompanyAppBar';
import MyAccountDialog from '../components/MyAccountDialog';
import LoginDialog from '../components/LoginDialog';
import QuestionsDialog from '../components/QuestionsDialog';

import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Title from 'reactjs-title'
import config, { getCompanyId } from '../../shared/config';

class CompanyPage extends React.Component {

  async componentDidMount() {
    const { match: { params } } = this.props;
    let companyId = getCompanyId(params.companySlug);
    let eventId = config.eventId;
    console.log("Loading company with id", companyId);
    await this.props.loadCompanyData(eventId, companyId);
    await this.props.startChatConditional();

    // TODO: if jobs enabled
    await this.props.loadJobs(eventId, companyId);
    await this.props.loadProfile();

    if( this.props.broadcastEnabled ) {
      console.log("[DEBUG] Broadcast Enabled");
      this.props.listenToBroadcast();
      await this.props.subToBroadcastChannel();
    } else {
      console.log("[DEBUG] Broadcast disabled - skipping RTC");
    }
  }

  componentWillUnmount() {
    this.props.leaveBroadcastChannel();
    this.props.releaseRTC();
  }

  render() {
    return this.props.ready ? (
      <>
      <MyAccountDialog open={this.props.accountDialogOpen}
        onClose={this.props.hideMyAccount}
        onSave={this.props.saveAccountDialog}
        formProps={this.props}
        onSubmit={this.props.submitAccountDialog}
        inProgress={this.props.profileInProgress}
      />

      <LoginDialog />

      <QuestionsDialog />

      <Title render={`${this.props.title}`} />

      <CompanyAppBar
        title={this.props.title}
        onBackClick={this.props.returnToEvent}
        onLogout={this.props.logout}
        onLogin={this.props.login}
        onMyAccount={this.props.showMyAccount}
        profile={this.props.profile} />

        <Grid container spacing={2} direction="row" justify="center" alignItems="stretch" style={{ height: '100%' }} >
          <Grid item xs={12} sm={5} md={3}>
            <Paper style={{ height: '100%' }} >
              <Grid container spacing={3} direction="column" justify="center" alignItems="stretch" style={{ marginTop: 0 }}  >
                <Grid item>
                    <img src={this.props.company.logo.thumb.url} alt='Logo' style={{ maxWidth: "60%", display: 'block',  marginLeft:'auto', marginRight:'auto' }} />
                </Grid>
                <Grid item>
                  {this.props.company.chat_enabled ?
                    <Box style={{padding: 20}}>
                      <Typography variant="subtitle1" display="block" gutterBottom>
                        Booth representatives:
                      </Typography>
                      <List>
                        {this.props.reps.map( rep => (<CompanyRep key={rep.id} profile={rep} />) )}
                      </List>
                      <ChatButton {...this.props} onClick={this.props.loadCompanyChat} />
                    </Box>
                  : <></> }
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={7} md={9}>
            <Paper style={{ height: '100%' }} >
              <CompanyTabs {...this.props} />
            </Paper>
          </Grid>
        </Grid>
    </>
    ) : <></>;}
}

const mapStateToProps = state => {
  return {
    ready: state.company.loaded,
    company: state.company.data,
    title: state.company.data.name,
    reps: state.company.users,
    stream: Object.values(state.broadcast.remoteStreams)[0],
    broadcastEnabled: state.company.settings.broadcast_enabled,
    messages: (state.broadcast.messages[`${state.company.eventId}:${state.company.companyId}`] || []),
    jobs: state.jobs.items,
    currentJob: (state.jobs.currentJobId ? state.jobs.items.find( (j) => j.id == state.jobs.currentJobId ) : null),
    jobApplyInProgress: state.applies.inProgress,
    jobApplies: state.applies.applies, // hash <jobId, bool>
    jobsPresent: state.jobs.items.length > 0,
    contents: state.company.contents,
    profile: state.profile.data,
    accountDialogOpen: state.company.accountDialogOpen,
    initialValues: state.profile.data,
    profileInProgress: state.profile.inProgress,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadCompanyData: async (eventId, companyId) => {
      return await dispatch(CompanyActions.loadCompanyData(eventId, companyId));
    },
    startChatConditional: () => dispatch( CompanyActions.startChatConditional() ),
    loadCompanyChat: () => {
      dispatch( ChatActions.enablePush() );
      return dispatch(CompanyActions.loadCompanyChat());
    },
    returnToEvent: () => {
      return dispatch(CompanyActions.returnToEvent());
    },
    logout: () => {
      return dispatch(CompanyActions.logout());
    },
    login: () => {
      dispatch(LoginActions.openLoginDialog());
    },
    showMyAccount: () => {
      dispatch(CompanyActions.openMyAccount());
    },
    hideMyAccount: () => {
      dispatch(CompanyActions.closeMyAccount());
    },
    saveAccountDialog: () => {
      dispatch( submit('profile') );
    },
    submitAccountDialog: async (values) => {
      await dispatch(ProfileActions.submitProfile());
      dispatch(CompanyActions.closeMyAccount());
    },
    listenToBroadcast: () => {
      dispatch(BroadcastActions.listenToBroadcast()); // RTC (video)
    },
    releaseRTC: () => {
      dispatch(BroadcastActions.releaseRTC()); // RTC release (agora)
    },
    sendMessage: (msg) => {
      dispatch(BroadcastActions.sendMessage(msg));
    },
    subToBroadcastChannel: async () => {
      await dispatch(BroadcastActions.subToBroadcast()); // websocket for messages
    },
    leaveBroadcastChannel: async () => {
      await dispatch(BroadcastActions.leaveBroadcast()); // websocket for messages
    },
    loadJobs: async (eventId, companyId) => {
      console.log("[DEBUG] Load jobs");
      await dispatch(JobsActions.loadJobs(eventId, companyId));
    },
    jobClick: (id) => {
      console.log("Job click", id);
      dispatch(JobsActions.openJob(id));
    },
    JobBackClick: () => {
      dispatch(JobsActions.closeJob());
    },
    submitJobApply: (values) => {
      dispatch(AppliesActions.createJobApply(values));
    },
    loadProfile: async () => dispatch(ProfileActions.fetchProfile()),
    requestLoginCode: (phone) => dispatch(LoginActions.requestLoginCode(phone)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyPage);
